<template>
  <div>
    <div class="modal-backdrop"></div>
    <div class="modal">
      <div class="modal-inner">
        <div class="custom-modal-header">
          <div class="title">
            <i class="fas fa-folder"></i>
            <span>Embed konfiguration</span>
          </div>
          <div class="close-btn">
            <div class="btn-close" @click="onModalClose"></div>
          </div>
        </div>
        <div class="custom-modal-content">
          <div class="mt-5" v-if="isLoading">
            <LoadingSpinner loadingCaption="loading data" />
          </div>
          <div v-if="!isLoading" class="wrapped-content">
            <ObjectMapper
              v-if="this.elements"
              :databaseSchema="JSON.stringify(this.elements)"
              ref="objectMapperRef"
              @onInputChange="updateScriptOnchange"
            />
          </div>
          <div v-if="!isLoading" class="script-viewer-wrapper">
            <div class="script-viewer">
              <div class="script-comment mt-0">{{ htmlStrings.start }}</div>
              <div class="script-div">{{ getWidgetDiv }}</div>
              <div class="script-js">
                {{ scriptHtmlTExt }}
              </div>
              <div class="script-comment">{{ htmlStrings.end }}</div>
              <div class="copy-clipboard-btn" @click="copyToClipboard()">
                Copy
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import LoadingSpinner from '../widgets/LoadingSpinner.vue';
import ObjectMapper from '../widgets/object-mapper.vue';

export default {
  name: 'CopyEmbedModal',
  data() {
    return {
      htmlText: '',
      scriptHtmlTExt: '',
      htmlStrings: {
        start: '<!-- Codelos Inline-Widget Beginn -->',
        end: '<!-- Codelos Inline-Widget Ende -->',
      },
    };
  },
  props: {
    copyEmbedModal: {
      required: true,
      type: Object,
      default: () => ({
        visible: false,
        loading: false,
        selectedFlow: {},
        elements: [],
      }),
    },
  },
  computed: {
    isLoading() {
      return this.copyEmbedModal.loading;
    },
    selectedFlow() {
      return this.copyEmbedModal.selectedFlow;
    },
    elements() {
      return this.copyEmbedModal.elements;
    },
    getWidgetDiv() {
      return ` <div id="codelos-inline-widget-${this.selectedFlow.id}"></div>`;
    },
  },
  methods: {
    showToaster(message, title, variant) {
      this.$bvToast.toast(message, {
        title,
        variant,
      });
    },
    copyToClipboard() {
      var dummy = document.createElement('textarea');
      // to avoid breaking orgain page when copying more words
      // cant copy when adding below this code
      // dummy.style.display = 'none'
      document.body.appendChild(dummy);
      dummy.value = this.htmlText;
      dummy.select();
      document.execCommand('copy');
      document.body.removeChild(dummy);
      this.showToaster(
        'Einbettungsfluss erfolgreich kopiert',
        'success',
        'success'
      );
    },
    generateScript(mapperObject) {
      const flowRunnerUrl = `${this.selectedFlow.executionUrl}/embed-script/${this.selectedFlow.id}?request_method=GET&include_id=true`;
      let finalUrl = '';

      if (mapperObject && Object.keys(mapperObject).length > 0) {
        let paramsString = '';
        Object.keys(mapperObject).map((key, i) => {
          let paramBreak =
            Object.keys(mapperObject).length === i + 1 ? '' : '&';

          if (mapperObject[key] !== '') {
            paramsString += `${key}=${mapperObject[key]}` + paramBreak;
          }
        });

        finalUrl = flowRunnerUrl + paramsString;
      } else {
        finalUrl = flowRunnerUrl;
      }

      const script =
        '<script' +
        ` id="codelos-inline-script-${this.selectedFlow.id}" ` +
        'src="' +
        finalUrl +
        // eslint-disable-next-line no-useless-escape
        '"><\/script>';

      const fullhtml =
        '<!-- Codelos Inline-Widget Beginn -->\n' +
        this.getWidgetDiv +
        '\n' +
        script +
        '\n<!-- Codelos Inline-Widget Ende -->';
      this.htmlText = fullhtml;
      this.scriptHtmlTExt = script;
    },
    updateScriptOnchange(val) {
      this.generateScript(JSON.parse(JSON.stringify(val)));
    },
    onModalClose() {
      this.$emit('closeModal');
    },
  },
  mounted() {
    this.generateScript();
  },
  components: {
    LoadingSpinner,
    ObjectMapper,
  },
};
</script>
<style scoped>
@import 'https://use.fontawesome.com/releases/v5.6.3/css/all.css';

.modal-backdrop {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal {
  padding: 0;
  width: 100%;
  height: 100%;
  background: transparent;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  border-radius: 10px;
  display: block;
}

.modal .modal-inner {
  width: 90%;
  height: auto;
  background: #fff;
  padding: 25px 40px 10px 43px;
  border-radius: 10px;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 0;
  right: 0;
  margin: 0 auto;
  height: 99%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.modal .btn-close {
  position: absolute;
  right: 0;
  top: 0;
  padding: 0;
}
.custom-modal-header {
  border-bottom: 1px solid #eee;
  box-sizing: border-box;
  display: block;
  position: relative;
  padding-bottom: 10px;
}
.modal .btn-close:focus {
  outline: none;
  box-shadow: none;
}

.custom-modal-header .title {
  font-size: 22px;
  color: #525252;
  float: none;
  margin-right: 0;
  padding-right: 0;
}

.custom-modal-header .title i {
  margin-right: 20px;
}

.custom-modal-content {
  min-height: 150px;
  margin: 20px 0;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
}

.custom-modal-content .wrapped-content {
  flex-grow: 1;
  padding: 10px 5px 5px 5px;
  border: 1px solid #dee3e9;
  margin-top: 5px;
  overflow-y: auto;
}

.custom-modal-content .script-viewer-wrapper {
  height: 35%;
  border: 1px solid #dee3e9;
  margin-top: 15px;
}

.custom-modal-content .script-viewer-wrapper .script-viewer {
  height: 100%;
  background: #2d2d2d;
  width: 100%;
  color: white;
  position: relative;
  padding: 15px;
  position: relative;
  line-height: 20px;
  font-size: 15px;
  overflow-y: scroll;
}

.custom-modal-content
  .script-viewer-wrapper
  .script-viewer
  .copy-clipboard-btn {
  position: absolute;
  top: 0;
  right: 0;
  background: #d9d9d9;
  color: black;
  padding: 5px 9px;
  cursor: pointer;
}

input:focus {
  outline: none;
}
.custom-modal-content
  .wrapped-content::v-deep
  .object-mapper
  input[type='text'] {
  padding: 8px 5px 8px 5px !important;
  border: 1px solid #dee3e9 !important;
  background: #fbfbff !important;
}

.custom-modal-content
  .wrapped-content::v-deep
  .object-mapper
  input[type='text']:focus {
  outline: none;
}

::v-deep .wrapped-content .database-form label {
  width: 160px;
  text-align: left;
}

::v-deep .wrapped-content .database-form input {
  width: 50%;
}
.script-viewer .script-comment {
  opacity: 0.6;
  margin: 15px 0;
}

.script-viewer .script-div {
  color: #b7f91c;
}

.script-viewer .script-js {
  color: #d8b1ff;
  word-wrap: break-word;
}

::v-deep .toast .toast-header button.close {
  margin-left: auto;
  margin-bottom: 0;
  font-size: 1.3rem;
  line-height: 0;
  color: #000;
  opacity: 0.5;
  border: none;
  background: transparent;
}
::v-deep .toast:not(.show) {
  display: block;
}
</style>
